// generated by svgr from images/twitter.svg

import React from 'react'

function TwitterIcon(props) {
  return (
    <svg viewBox='0 0 28 30' {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.19 0a2 2 0 00-2 2v25.58c0 1.1.9 2 2 2H26a2 2 0 002-2V2a2 2 0 00-2-2H2.19zm20.2 8.37a8.5 8.5 0 002.57-.75 9.4 9.4 0 01-2.23 2.46l.02.61c0 6.27-4.49 13.49-12.69 13.49-2.51 0-4.86-.78-6.83-2.13a8.6 8.6 0 006.6-1.96 4.5 4.5 0 01-4.16-3.3 4.24 4.24 0 002-.08 4.68 4.68 0 01-3.57-4.65V12c.6.36 1.3.57 2.02.6a4.95 4.95 0 01-1.38-6.33 12.42 12.42 0 009.2 4.95c-.08-.35-.12-.7-.12-1.08 0-2.62 2-4.74 4.45-4.74 1.29 0 2.44.58 3.26 1.5a8.61 8.61 0 002.83-1.15 4.72 4.72 0 01-1.96 2.62z'
      />
    </svg>
  )
}

export default TwitterIcon
